import {useQuery} from 'react-query'
import {PasswordEditModalForm} from './PasswordEditModalForm'
import {useListView} from '../core/ListViewProvider'
import {getUserById} from '../core/_requests'
import {QUERIES, isNotEmpty} from '../../../../../_handld/helpers'

const PasswordEditModalFormWrapper = () => {
  const {itemIdForUpdate, setItemIdForUpdate} = useListView()
  const enabledQuery: boolean = isNotEmpty(itemIdForUpdate)
  const {
    isLoading,
    data: user,
    error,
  } = useQuery(
    `${QUERIES.USERS_LIST}-user-${itemIdForUpdate}`,
    () => {
      return getUserById(itemIdForUpdate)
    },
    {
      cacheTime: 0,
      enabled: enabledQuery,
      onError: (err) => {
        setItemIdForUpdate(undefined)
        console.error(err)
      },
    }
  )

  if (!itemIdForUpdate) {
    return <PasswordEditModalForm isUserLoading={isLoading} user={{id: undefined}} />
  }

  if (!isLoading && !error && user) {
    return <PasswordEditModalForm isUserLoading={isLoading} user={user} />
  }

  return null
}

export {PasswordEditModalFormWrapper}
